export default __webpack_public_path__ + "static/media/books2-afterA-1440w.4fd426eb.avif";